import { TYPES } from '@/engine/ioc';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react';
import type { QuadroLayoutController } from './QuadroLayout.controller';
import { SimpleMenuItem } from '@/components/header/buttons/SimpleMenuItem';
import WindowIcon from '@mui/icons-material/Window';
// import ViewSidebarIcon from '@mui/icons-material/ViewSidebar';
import { QuadroLayoutType } from './QuadroLayoutState.store';
import { useSurgerySpecificUiConfigValue } from '@/engine/app/modules/ui';

export const QuadroLayoutTopBarButton: React.FC = observer(() => {
  const showQuadroLayoutSwitch = useSurgerySpecificUiConfigValue<boolean>('showQuadroLayoutSwitch');

  if (!showQuadroLayoutSwitch) {
    return null;
  }

  const controller = useInjection<QuadroLayoutController>(TYPES.QuadroLayoutController);

  return (
    <SimpleMenuItem
      icon={WindowIcon}
      title="Layout"
      testId="quadro-layout-switch-button"
      onClick={() =>
        controller.setActiveQuadroLayoutType(
          controller.activeQuadroLayoutType === QuadroLayoutType.ACCENTED
            ? QuadroLayoutType.SYMMETRICAL
            : QuadroLayoutType.ACCENTED
        )
      }
    />
  );
});
